"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const DataProvider_1 = tslib_1.__importDefault(require("../DataProvider"));
const ApiClient_1 = require("../lib/ApiClient");
const graphql_tag_1 = tslib_1.__importDefault(require("graphql-tag"));
exports.isStringTransactionDetails = (details) => {
    var _a;
    return ((_a = details) === null || _a === void 0 ? void 0 : _a[ApiClient_1.typenameSymbol]) === "StringTransactionDetails";
};
exports.isDepositTransactionDetails = (details) => {
    var _a;
    return ((_a = details) === null || _a === void 0 ? void 0 : _a[ApiClient_1.typenameSymbol]) === "DepositTransactionDetails";
};
exports.isPayoutTransactionDetails = (details) => {
    var _a;
    return ((_a = details) === null || _a === void 0 ? void 0 : _a[ApiClient_1.typenameSymbol]) === "PayoutTransactionDetails";
};
exports.isChargebackTransactionDetails = (details) => {
    var _a;
    return ((_a = details) === null || _a === void 0 ? void 0 : _a[ApiClient_1.typenameSymbol]) === "ChargebackTransactionDetails";
};
class TransactionProvider extends DataProvider_1.default {
    get fragments() {
        return {
            Transaction: () => `
        ... on Transaction {
          id
          userId
          user {
            ${this.getFragment("UserPublicData")}
          }
          amount
          details {
            __typename
            ${this.getFragment("TransactionDetails")}
          }
          time
          type
          contentType
          reference
        }
      `,
            TransactionDetails: () => `
        ... on DepositTransactionDetails {
          packageId
          paymentSystem
        }
        ... on PayoutTransactionDetails {
          payeeInfo {
            ${this.getFragment("PayeeInformation")}
          }
          payoutRequestId
        }
        ... on StringTransactionDetails {
          description
        }
        ... on ChargebackTransactionDetails {
          depositTransactionId
        }
      `,
            EarningReportItem: () => `
        ... on EarningReportItem {
          timeFrom
          timeTo
          details {
            type
            contentType
            userId
            amount
            totalAmount
            fee
            agentFee
          }          
        }
      `,
            PlatformEarningReportItem: () => `
        ... on PlatformEarningReportItem {
          userId
          user {
            ${this.getFragment("User")}
          }
          amount
          totalAmount
          fee
          agentFee
        }`,
        };
    }
    find({ data }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.query("transactionsSearch", { data }, `
      result {
        ${this.getFragment("Transaction")}
      }
      size
      page
      hasNextPage
      hasPrevPage
      totalPages
      totalRecords
    `);
        });
    }
    getBalance({ userIds }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.query("transactionGetBalances", { userIds });
        });
    }
    getPendingBalance({ userIds }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.query("transactionGetPendingBalances", { userIds });
        });
    }
    createManual({ data }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.mutate("transactionCreateManual", { data }, this.getFragment("Transaction"));
        });
    }
    createPayout({ data }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.mutate("transactionCreatePayout", { data }, this.getFragment("Transaction"));
        });
    }
    subscribeUserBalanceUpdated(onData, onError) {
        return this.api.subscribe({
            query: graphql_tag_1.default `
          subscription {
            userBalanceUpdated
          }
        `,
        }, data => {
            onData(data.userBalanceUpdated);
        }, onError);
    }
    getEarningReports({ data }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.query("transactionEarningReportSearch", { data }, this.getFragment("EarningReportItem"));
        });
    }
    getPlatformEarningReport({ data, }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.query("transactionPlatformEarningReportSearch", { data }, this.getPageableFragment("PlatformEarningReportItem"));
        });
    }
}
exports.TransactionProvider = TransactionProvider;
//# sourceMappingURL=TransactionProvider.js.map